import m_03_2069 from './KZ.M.03.2069.svg'
import t_03_e0810 from './KZ.T.03.E0810.svg'

export default [
  m_03_2069,
  t_03_e0810
]
